import { Button, Form, Input } from "antd";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import brandImg from "../../assets/images/brand.jpg";
import { API_URL } from "../../services/api/config";
import { api } from "../../services/api/api.index.js";
import { localSaveToken } from "../../utils/localStorage/index.js";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "../../components/notification";
import { UserContext } from "../../context/context";
import { localSaveRefreshToken } from "../../utils/localStorage";
const SignIn = () => {
  const [formStep1] = Form.useForm();
  const [formStep2] = Form.useForm();
  const [formStep3] = Form.useForm();
  const [formStep4] = Form.useForm();
  const { state, dispatch } = useContext(UserContext);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [count, setCount] = useState(1);

  const handleFinishStep1 = async (e) => {
    try {
      setLoading(true);
      let { data } = await api.postLogin(`${API_URL}api/v1/auth/login`, {
        username: e.username,
        password: e.password,
      });
      notifySuccess("Đăng nhập thành công!");

      localSaveToken(data.accessToken);
      localSaveRefreshToken(data.refreshToken);
      navigate("/");

      setLoading(false);
    } catch (e) {
      setLoading(false);
      notifyError("Tên đăng nhập/ mật khẩu không chính xác");
    }

    // setStep(step + 1);
  };
  const handleFinishStep2 = async (e) => {
    setLoading(true);

    try {
      await api.post(`${API_URL}api/v1/auth/forget-password`, {
        username: e.username,
      });
      setStep(3);
      setLoading(false);
    } catch (e) {
      setLoading(false);

      notifyError(`Có lỗi xảy ra!`);
    }
  };

  const handleFinishStep3 = async (e) => {
    try {
      setLoading(true);
      await api.post(`${API_URL}core/v1/auth/verify`, {
        verify_code: e.otp,
      });
      setLoading(false);
      navigate("/connect");
    } catch (e) {
      setLoading(false);
      if (count === 3) {
        notifyError(`Vui lòng đăng nhập lại`);
        setStep(1);
        formStep1.setFieldsValue({
          email: null,
          password: null,
        });
        formStep2.setFieldValue("otp", null);
        setCount(1);
      } else {
        setCount(count + 1);
        notifyError(
          `Mã xác nhận không chính xác, bạn còn ${3 - count} lần nhập`
        );
      }
    }
  };

  const handleFinishStep4 = async (e) => {
    try {
      setLoading(true);
      await api.post(`${API_URL}core/v1/auth/verify`, {
        verify_code: e.otp,
      });
      setLoading(false);
      navigate("/connect");
    } catch (e) {
      setLoading(false);
      if (count === 3) {
        notifyError(`Vui lòng đăng nhập lại`);
        setStep(1);
        formStep1.setFieldsValue({
          email: null,
          password: null,
        });
        formStep2.setFieldValue("otp", null);
        setCount(1);
      } else {
        setCount(count + 1);
        notifyError(
          `Mã xác nhận không chính xác, bạn còn ${3 - count} lần nhập`
        );
      }
    }
  };
  const handleKeyUpStep1 = (event) => {
    // Enter
    if (event.keyCode === 13) {
      formStep1.submit();
    }
  };

  const handleKeyUpStep2 = (event) => {
    // Enter
    if (event.keyCode === 13) {
      formStep2.submit();
    }
  };

  const handleKeyUpStep3 = (event) => {
    // Enter
    if (event.keyCode === 13) {
      formStep3.submit();
    }
  };

  const handleKeyUpStep4 = (event) => {
    // Enter
    if (event.keyCode === 13) {
      formStep4.submit();
    }
  };
  return (
    <div className="signin__mainBackground">
      <div className="signin__background">
        <img src={brandImg} alt="" />
      </div>
      <div className="signin">
        {step === 1 && (
          <Form
            onKeyUp={handleKeyUpStep1}
            form={formStep1}
            onFinish={handleFinishStep1}
            className="signin__form"
          >
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI CMS</p>
            </div>
            <span>
              Email <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item
              rules={[{ required: true, message: "Vui lòng không bỏ trống!" }]}
              className="signin__form__item"
              name="username"
            >
              <Input placeholder="Nhập tên đăng nhập" />
            </Form.Item>

            <span>
              Mật khẩu <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item
              rules={[{ required: true, message: "Vui lòng không bỏ trống!" }]}
              className="signin__form__item"
              name="password"
            >
              <Input.Password placeholder="Nhập mật khẩu" />
            </Form.Item>

            <div className="signin__form__submit">
              <div
                style={{
                  width: "calc( 100% - 8px )",
                  color: "rgb(56, 114, 174)",
                  cursor: "pointer",
                }}
                onClick={() => setStep(2)}
              >
                Quên mật khẩu?
              </div>
              <Button
                loading={loading}
                style={{ width: "calc( 100% - 8px )" }}
                onClick={() => formStep1.submit()}
              >
                Đăng nhập
              </Button>
            </div>
          </Form>
        )}
        {step === 2 && (
          <Form
            onKeyUp={handleKeyUpStep2}
            form={formStep2}
            onFinish={handleFinishStep2}
            className="signin__form"
          >
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI CMS</p>
              <p className="signin__form__info__subinfo">Lấy lại mật khẩu</p>
            </div>

            <Form.Item
              style={{ marginTop: "16px" }}
              rules={[{ required: true, message: "Vui lòng không bỏ trống!" }]}
              className="signin__form__item"
              name="username"
            >
              <Input placeholder="Nhập email đã đăng kí" />
            </Form.Item>

            <div className="signin__form__submit">
              <Button
                loading={loading}
                style={{ width: "100%" }}
                onClick={() => formStep2.submit()}
              >
                Tiếp tục
              </Button>
            </div>
          </Form>
        )}
        {step === 3 && (
          <Form
            onKeyUp={handleKeyUpStep3}
            form={formStep3}
            onFinish={handleFinishStep3}
            className="signin__form"
          >
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI CMS</p>
              <p className="signin__form__info__subinfo">
                Vui lòng kiểm tra Email và làm theo hướng dẫn để cập nhật lại
                mật khẩu mới
              </p>
            </div>

            <div className="signin__form__submit">
              <div
                style={{
                  width: "calc( 100% )",
                  color: "rgb(56, 114, 174)",
                  cursor: "pointer",
                  textAlign: "center",
                }}
                onClick={() => setStep(4)}
              >
                Bạn chưa nhận được email? Gửi lại(30s)
              </div>
            </div>
          </Form>
        )}
        {step === 4 && (
          <Form
            onKeyUp={handleKeyUpStep4}
            form={formStep4}
            onFinish={handleFinishStep4}
            className="signin__form"
          >
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI CMS</p>
              <p className="signin__form__info__subinfo">
                Cập nhật mật khẩu mới
              </p>
            </div>
            <span>
              Mật khẩu mới: <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item
              rules={[{ required: true, message: "Vui lòng không bỏ trống!" }]}
              className="signin__form__item"
              name="password"
            >
              <Input.Password placeholder="Nhập mật khẩu mới" />
            </Form.Item>

            <span>
              Nhập lại mật khẩu mới: <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item
              rules={[{ required: true, message: "Vui lòng không bỏ trống!" }]}
              className="signin__form__item"
              name="confirmPassword"
            >
              <Input.Password placeholder="Nhập lại mật khẩu mới" />
            </Form.Item>

            <div className="signin__form__submit">
              <Button
                loading={loading}
                style={{ width: "calc( 100%)" }}
                onClick={() => formStep4.submit()}
              >
                Hoàn tất
              </Button>
            </div>
          </Form>
        )}
        {/* {step === 3 && (
          <Form
            form={formStep3}
            onFinish={handleFinishStep3}
            className="signin__form"
          >
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI MASTER</p>
              <p className="signin__form__info__subinfo">
                Thông tin đăng nhập Express Partners
              </p>
            </div>

            <span>
              Email <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item className="signin__form__item" name="email">
              <Input placeholder="Nhập email" />
            </Form.Item>

            <span>
              Mật khẩu <span style={{ color: "red" }}>*</span>
            </span>
            <Form.Item className="signin__form__item" name="phone">
              <Input placeholder="Nhập mật khẩu" />
            </Form.Item>
            <div
              className="signin__form__submit"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{ width: "calc(50% - 8px)" }}
                onClick={() => formStep3.submit()}
              >
                Kiểm tra
              </div>
              <div
                style={{ width: "calc(50% - 8px)" }}
                onClick={() => formStep3.submit()}
              >
                Lưu
              </div>
            </div>
          </Form>
        )}
        {step === 4 && (
          <div className="signin__form">
            <div className="signin__form__info">
              <p className="signin__form__info__header">DNI MASTER</p>
              <p className="signin__form__info__subinfo__sub">
                Lưu thông tin đăng nhập Express Partners thành công
              </p>
            </div>
            <div className="signin__form__submit">
              <div onClick={() => setStep(1)} style={{ width: "100%" }}>
                Trở về trang trước
              </div>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default SignIn;
